<template>
    <div class="banner" >
        <template v-if="tipo == 'Lateral'">
            <div class="w-100 d-flex flex-wrap justify-content-center">
                <a @click="bloqueiaClick(this); gravaLogBannerClique(bannerPrimario.title)" :class="'mb-3 '+(duplo?'mr-0 mr-lg-2':'')" :href="bannerPrimario.link" :target="bannerPrimario.target" :title="bannerPrimario.dsTitulo" v-if="bannerPrimario.img != ''">
                    <img :class="(tipo=='Lateral'?'banner-lateral':'banner-horizontal')" :src="bannerPrimario.img" :title="bannerPrimario.title" :alt="bannerPrimario.title" />
                </a>
                <a @click="bloqueiaClick(this); gravaLogBannerClique(bannerSecundario.title)" class="" :href="bannerSecundario.link" :target="bannerSecundario.target" :title="bannerSecundario.dsTitulo" v-if="duplo && bannerSecundario.img != ''">
                    <img :class="(tipo=='Lateral'?'banner-lateral':'banner-horizontal')" :src="bannerSecundario.img" :title="bannerSecundario.title" :alt="bannerSecundario.title" />
                </a>
            </div>
            
        </template>
        <template v-else>
            <div class="row">
                <div :class="(duplo?'col-12 col-md-6':'col-12 d-flex justify-content-center')">
                    <a @click="bloqueiaClick(this); gravaLogBannerClique(bannerPrimario.title)" :href="bannerPrimario.link" :target="bannerPrimario.target" :title="bannerPrimario.dsTitulo" v-if="bannerPrimario.img != ''">
                        <img :class="(tipo=='Lateral'?'banner-lateral':'banner-horizontal')" :src="bannerPrimario.img" :title="bannerPrimario.title" :alt="bannerPrimario.title" />
                    </a>
                </div>
                <div class="col-12 col-md-6" v-if="duplo">
                    <a @click="bloqueiaClick(this); gravaLogBannerClique(bannerSecundario.title)" :href="bannerSecundario.link" :target="bannerSecundario.target" :title="bannerSecundario.dsTitulo" v-if="bannerSecundario.img != ''">
                        <img :class="(tipo=='Lateral'?'banner-lateral':'banner-horizontal')" :src="bannerSecundario.img" :title="bannerSecundario.title" :alt="bannerSecundario.title" />
                    </a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios' 
    import $ from 'jquery'
    //import moment from 'moment'

    export default {
        name: 'BannerDuplo',
        props: {
            tipo: {
                type: String,
                default: "Lateral",
            },
            duplo: {
                type: Boolean,
                default: true,
            },
        },
        data: function () {
            return {
                bannerPrimario: {
                    img: '',
                    link: '',
                    target: '_blank',
                    title: '',
                    tpBanner: '',
                },
                bannerSecundario: {
                    img: '',
                    link: '',
                    target: '_blank',
                    title: '',
                    tpBanner: '',
                },
                lstBannersPrimario: [],
                lstBannersSecundario: [],

                qtdRecords: 0,
                totalRecords: false,
                take: 10,
                skip: 0,
            }
        },
        methods: {

            load() {
                let $this = this;
                axios.get(`${urlApi}/Banner/Get`, { params: { take: $this.take, index: $this.skip} })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.qtdRecords = res.data.data.qtdRecords;
                                if (res.data.data.qtdRecords <= ($this.take * ($this.skip == 0 ? 1 : $this.skip))) {
                                    $this.totalRecords = true;
                                }

                                $this.skip = $this.skip++;
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    var item = res.data.data.rows[i];
                                    // ATIVA E DESATIVA LOG
                                    item.log = true;
                                    if (i % 2 == 0) {
                                        $this.lstBannersPrimario.push(item);
                                    } else {
                                        $this.lstBannersSecundario.push(item);
                                    }
                                    
                                }
                                $this.playBannerPrimario();
                                $this.playBannerSecundario();

                            }
                        } else {
                            avisoErro("Não foi possível carregar os comentários");
                            $this.lstComentarios = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os comentários");
                        $this.lstComentarios = null;
                    });
            },


            playBannerPrimario() {
                let $this = this;
                let i = 1;
                let limit = $this.lstBannersPrimario.length;
                let lista = $this.lstBannersPrimario;

                if (lista[0]) {
                    $this.bannerPrimario = lista[0];
                    $this.regrasBannerPrimario($this.bannerPrimario);
                }

                if (lista.length > 1) {
                    setInterval(function () {
                        if (!lista[i]) {
                            i = 0;
                        }

                        if (lista[i]) {
                            $this.bannerPrimario = lista[i];
                            $this.regrasBannerPrimario($this.bannerPrimario);
                        }

                        i = (i < limit) ? i + 1 : 0;
                    }, 5000);
                }
            },

            playBannerSecundario() {
                let $this = this;
                let i = 1;
                let limit = $this.lstBannersSecundario.length;
                let lista = $this.lstBannersSecundario;

                if (lista[0]) {
                    $this.banner = lista[0];
                    $this.regrasBannerSecundario($this.banner);
                }

                if (lista.length > 1) {
                    setInterval(function () {
                        if (!lista[i]) {
                            i = 0;
                        }

                        if (lista[i]) {
                            $this.banner = lista[i];
                            $this.regrasBannerSecundario($this.banner);
                        }

                        i = (i < limit) ? i + 1 : 0;
                    }, 5000);
                }
            },

            regrasBannerPrimario(p_banner) {
                let $this = this;
                if ($this.tipo == "Horizontal") {
                    //$('#' + $this.id).fadeOut(300, function () {

                    //    $(this).fadeIn();
                    //});
                    $this.bannerPrimario.img = p_banner.urlImagemBannerTopo;
                } else {
                    //$('#' + $this.id).fadeOut(300, function () {

                    //    $(this).fadeIn();
                    //});
                    $this.bannerPrimario.img = p_banner.urlImagemBannerLateral;
                }

                $this.bannerPrimario.link = p_banner.urlBanner;
                $this.bannerPrimario.title = p_banner.nmBanner;

                if ($this.bannerPrimario.log) {
                    $this.gravaLogBannerView($this.bannerPrimario.title);
                    $this.trocaStatusLogBanner(1, $this.bannerPrimario.idBanner);
                }
            },

            regrasBannerSecundario(p_banner) {
                let $this = this;
                if ($this.tipo == "Horizontal") {
                    $this.bannerSecundario.img = p_banner.urlImagemBannerTopo;
                } else {
                    $this.bannerSecundario.img = p_banner.urlImagemBannerLateral;
                }

                $this.bannerSecundario.link = p_banner.urlBanner;
                $this.bannerSecundario.title = p_banner.nmBanner;

                if ($this.bannerSecundario.log) {
                    $this.gravaLogBannerView($this.bannerPrimario.title);
                    $this.trocaStatusLogBanner(2, $this.bannerSecundario.idBanner);
                }
            },

            trocaStatusLogBanner(tp, idBanner) {
                let $this = this;
                if (tp == 1) {
                    for (let i = 0; i < $this.lstBannersPrimario.length; i++) {
                        if ($this.lstBannersPrimario[i].idBanner == idBanner) {
                            $this.lstBannersPrimario[i].log = false;
                            $this.bannerPrimario.log = false;
                        }
                    }
                } else {
                    for (let i = 0; i < $this.lstBannersSecundario.length; i++) {
                        if ($this.lstBannersSecundario[i].idBanner == idBanner) {
                            $this.lstBannersSecundario[i].log = false;
                            $this.bannerSecundario.log = false;
                        }
                    }
                }
                
            },

            gravaLogBannerView(nmBanner) {
                axios.post(`${urlApi}/Banner/LogBannerView`, { nmBanner: nmBanner }, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            // aviso ok
                            console.log("Log Banner");
                        } else {
                            console.log("Erro Log Banner");
                        }
                    })
                    .catch(function () {
                        console.log("Erro Log Banner");
                    });
            },

            gravaLogBannerClique(nmBanner) {
                axios.post(`${urlApi}/Banner/LogBannerClique`, { nmBanner: nmBanner }, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            // aviso ok
                            console.log("Log Banner");
                        } else {
                            console.log("Erro Log Banner");
                        }
                    })
                   .catch(function(){
                        console.log("Erro Log Banner");
                    });
            },

            bloqueiaClick(elemento) {
                $(elemento).css("pointerEvents", "none");
                setTimeout(function () {
                    $(elemento).css("pointerEvents", "");
                }, 5000);
            },

        },
        created: function () {
            this.load();
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .banner {
        .banner-lateral {
            max-width: 100%;
            height: auto;
            max-height: 300px;
        }

        .banner-horizontal {
            max-height: 200px !important;
            max-width: 100% !important;
            height: auto !important;
        }
    }

</style>

